import Rate from './src/rate.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToRate: SFCWithInstall<typeof Rate> = withInstall(Rate)

export * from './src/instance'
